module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown tasks-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm._f("count")(_vm.userInfo.tasks)) + " ")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm._f("count")(_vm.userInfo.tasks)) + " task(s)")]), _vm._v(" "), (_vm.userInfo.tasks.length > 0) ? _c('li', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.userInfo.tasks.length > 0) ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("View all tasks")])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('h3', [_vm._v("\n              Design some buttons\n              "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("20%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-aqua",
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "20",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("20% Complete")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52709f56"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/TasksMenu.vue
// module id = 341
// module chunks = 1